export const createDefaultScores = (
  rounds: number,
  currentRound?: number
): (number | undefined)[] => {
  return Array.from({ length: rounds }, (_, i) =>
    currentRound !== undefined && i < currentRound ? 0 : undefined
  );
};
